import { createContext } from 'react';
interface ContentSignatureContext {
  contentSignature: string;
};

export default createContext<ContentSignatureContext>({ contentSignature: '' });
